import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LessonWidgetStore } from './typings';

const initialState: LessonWidgetStore = {
    shouldShowLessonWidget: false,
    shouldShowLessonWidgetTooltip: false,
};

const slice = createSlice({
    name: 'LESSON_WIDGET',
    initialState: initialState,
    reducers: {
        startListen: () => {},
        stopListen: () => {},
        toggleLessonWidget: (state, action: PayloadAction<boolean>) => {
            state.shouldShowLessonWidget = action.payload;
        },
        toggleLessonWidgetTooltip: (state, action: PayloadAction<boolean>) => {
            state.shouldShowLessonWidgetTooltip = action.payload;
        },
    },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
